import grapesjs from "grapesjs";
import { mergeTagCategories, mergeTags } from "../../../utils/mergeTags";

let mergeTagsHtml =
  '<select style="width: 300px;"  placeholder="" class="merge-tags-select"><option value= "">Select Merge tag</option>';

mergeTagCategories.forEach((category) => {
  mergeTagsHtml +=
    '<optgroup class="' + category.id + '" label="' + category.label + '"  >';
  mergeTags.forEach((mergeTag) => {
    if (mergeTag.category === category.id) {
      mergeTagsHtml +=
        '<option value="' + mergeTag.id + '" >' + mergeTag.label + "</option>";
    }
  });

  mergeTagsHtml += "</optgroup>";
});

mergeTagsHtml += "</select>";

// create custom rte options plugin
grapesjs.plugins.add("customRteOptions", (editor) => {
  // remove built in link option and add our own
  editor.RichTextEditor.remove("link");

  editor.RichTextEditor.add("hyperlink", {
    icon: "&#128279;",
    attributes: { title: "Hyperlink" },
    result: (rte) => {
      var component = editor.getSelected();

      if (component.is("link")) {
        component.replaceWith(`${component.get("content")}`);
      } else {
        var range = rte.selection().getRangeAt(0);

        var container = range.commonAncestorContainer;
        if (container.nodeType === 3) container = container.parentNode;

        if (container.nodeName === "A") {
          var sel = rte.selection();
          sel.removeAllRanges();
          range = document.createRange();
          range.selectNodeContents(container);
          sel.addRange(range);
          rte.exec("unlink");
        } else {
          var url = window.prompt("Enter the URL to link to:");
          if (url)
            rte.insertHTML(
              `<a class="link" href="${url}">${rte.selection()}</a>`
            );
        }
      }
    },
  });

  editor.RichTextEditor.add("superscript", {
    icon: "<b>S<sup>s</sup></b>",
    attributes: { title: "Superscript" },
    result: (rte) => rte.exec("superscript"),
  });

  editor.RichTextEditor.add("subscript", {
    icon: "<b>S<sub>s</sub></b>",
    attributes: { title: "Subscript" },
    result: (rte) => rte.exec("subscript"),
  });

  editor.RichTextEditor.add("indent", {
    icon: "&#8594;",
    attributes: { title: "Indent" },
    result: (rte) => rte.exec("indent"),
  });

  editor.RichTextEditor.add("outdent", {
    icon: "&#8592;",
    attributes: { title: "Outdent" },
    result: (rte) => rte.exec("outdent"),
  });

  editor.RichTextEditor.add("orderedList", {
    icon: "1.",
    attributes: { title: "Ordered List" },
    result: (rte) => rte.exec("insertOrderedList"),
  });

  editor.RichTextEditor.add("unorderedList", {
    icon: "&#8226;",
    attributes: { title: "Unordered List" },
    result: (rte) => rte.exec("insertUnorderedList"),
  });

  // Add all merge categories
  // mergeTagCategories.forEach((category) => {
  editor.RichTextEditor.add("hihij", {
    icon: mergeTagsHtml,
    attributes: {
      "data-custom-button": true,
      // title: category.id
    },
    //Bind the 'result' on 'change' listener
    event: "change",
    result: (rte, action) => {
      rte.insertHTML(action.btn.firstChild.value);
    },
    //Reset the select on change
    update: (rte, action) => {
      // window.jQuery('.merge-tags-select').val(null);
      // action.btn.firstChild.value = "";
    },
  });
  // });
});
